
import React from 'react';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface EdgeFiltersProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  filterRelationship: string;
  onRelationshipFilterChange: (value: string) => void;
}

const EdgeFilters: React.FC<EdgeFiltersProps> = ({
  searchTerm,
  onSearchChange,
  filterRelationship,
  onRelationshipFilterChange
}) => {
  const relationshipTypes = [
    { value: 'prerequisite', label: 'Prerequisite' },
    { value: 'related', label: 'Related' },
    { value: 'deepens', label: 'Deepens' },
    { value: 'critiques', label: 'Critiques' },
    { value: 'applies', label: 'Applies' },
    { value: 'exemplifies', label: 'Exemplifies' }
  ];

  return (
    <div className="flex gap-2">
      <Input
        placeholder="Search connections..."
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        className="w-64"
      />
      <Select value={filterRelationship} onValueChange={onRelationshipFilterChange}>
        <SelectTrigger className="w-40">
          <SelectValue placeholder="All types" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All types</SelectItem>
          {relationshipTypes.map((type) => (
            <SelectItem key={type.value} value={type.value}>
              {type.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default EdgeFilters;
